<template>
  <normal-layout
      :title="'银行卡'"
      :content-background-color="'#F0F0F4'"
  >
    <template #left-btn>
      <left-button/>
    </template>
    <template #content>
      <div class="banks-container">
        <div class="item" v-for="(value,index) in cardList" :key="index">
          <div class="detail">
            <bank-card :info="value"/>
            <div class="set">
              <button
                  :class="{'is-active':value.bindingDefault==='0'}"
                  @click="setDefaultCard(value)">
                {{ value.bindingDefault === '1' ? '默认卡' : '设为默认卡' }}
              </button>
            </div>
          </div>
        </div>
        <div class="buttons" @click="addCard">
          <p>＋添加银行卡</p>
        </div>
        <bank-identity class="bl-identity"/>
      </div>
    </template>
  </normal-layout>
</template>

<script>
import BankCard from './components/BankCard'
import NormalLayout from '../../components/actionbar/BasicLayout'
import LeftButton from '../../components/actionbar/TopLeftButton'
import BankIdentity from './components/BankIdentity'
import { queryBankCardList, setDefault } from '@/request/api.encryptor'
import { Toast } from 'vant'
import { showLoading, verdictEmpty } from '@/utils/tools'

export default {
  name: 'BankList',
  components: {
    BankCard,
    NormalLayout,
    LeftButton,
    BankIdentity
  },
  data() {
    return {
      cardList: [],
      defaultCard: '',
      addCardTimer: null,
      testCard: [{
        acctOpenBranchName: '中国华夏银行股份有限公司总行',
        memberAcctNo: '1234123412341234567',
        // 0是非默认， 1是默认
        bindingDefault: '0',
        eiconBankBranchId: '304100040000'
      }]
    }
  },
  mounted() {
    this.getBankCardList()
    this.$nextTick(() => {
      window.JD_Resume = () => {
        this.getBankCardList()
      }
    })
  },
  methods: {
    getBankCardList() {
      showLoading()
      queryBankCardList()
          .then(res => {
            Toast.clear()
            const { code = 1, info = [], msg = '' } = res || {}
            if (code !== 0) {
              Toast(msg)
              return
            }
            this.cardList = info
          })
          .catch(err => {
            Toast.clear()
            err && Toast.fail(err)
          })
    },
    setDefaultCard(val) {
      const { bindingDefault = '0', memberAcctNo = '' } = val || {}
      if (bindingDefault === '1') {
        Toast('已经是默认卡了')
        return
      }
      setDefault()
          .then(res => {
            const { code = 1, msg = '' } = res || {}
            if (code !== 0) {
              Toast(verdictEmpty(msg) ? '默认卡设置失败' : msg)
              return
            }
            this.checkCardIsDefault(memberAcctNo)
          })
          .catch(() => {
            Toast('默认卡设置失败')
          })
    },
    addCard() {
      this.$JD.nativeRouter({
        url: '/wallet/addBankCard'
      })
    },
    checkCardIsDefault(num) {
      if (!num) {
        return
      }
      for (let card of this.cardList) {
        const { memberAcctNo = '' } = card || {}
        if (memberAcctNo === num) {
          card.bindingDefault = '1'
        } else {
          card.bindingDefault = '0'
        }
      }
    }
  }
}
</script>

<style lang="scss">
.banks-container {
  padding: 0 0.133rem;
  margin-bottom: 2rem;

  .item {
    margin-top: 0.133rem;

    .detail {
      position: relative;

      .set {
        position: absolute;
        left: 0;
        top: 0;
        padding: 0.1rem;
        width: 100%;
        display: flex;
        justify-content: flex-end;
        font-size: 0.16rem;

        button {
          border-radius: 0.027rem;
          border: 1px solid rgba(255, 255, 255, 0.45);
          color: rgba(252, 252, 252, 0.45);
          background: none;
        }

        button.is-active {
          border-radius: 0.027rem;
          border: 1px solid rgba(255, 255, 255, 1);
          color: rgba(252, 252, 252, 1);
          padding: 1px 3px;
        }
      }
    }
  }

  .buttons {
    height: .667rem;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: white;
    border-radius: .053rem;
    margin-top: .133rem;
    margin-bottom: .133rem;

    p {
      color: #8B8B8B;
      font-size: .2rem;
    }
  }

  .bl-identity {
    background-color: #F0F0F4;
  }
}
</style>
